<template>
  <div>
    <div class="content-header" v-if="!embedded">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">{{ this.$route.name }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active"><i v-bind:class="routeIcon"></i> {{ $t(this.$route.name) }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <b-modal
        ref="editFormModal"
        size="lg"
        no-close-on-backdrop
        no-close-on-esc
        :title="editModalTitle"
        :static="true"
        :lazy="true"
    >
      <edit-form ref="editForm"></edit-form>

      <template #modal-footer>
        <b-row class="mt-3">
          <b-col class="">
            <button type="button" class="btn mr-1 btn-primary float-right" v-on:click="saveSidebetName">Save</button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <section class="content">
      <div class="container-fluid">
        <b-row class="col-lg-12">
          <b-form-group class="col-lg-12 col-md-12 col-sm-6">
            <button type="button" class="btn mr-1 btn-success" v-on:click="showEditModal({})"><i class="fas fa-plus"></i> Create</button>
          </b-form-group>
        </b-row>

        <div class="row col-12" id="loading-container">
          <div class="col-12 mb-10">
            <div class="mb-10">
              <div class="table-wrapper mb-10">
                <b-table
                    :striped="true"
                    :small="true"
                    :hover="true"
                    :empty-text="emptyText"
                    show-empty
                    :sort-by="sortBy"
                    :sort-desc="sortDesc"
                    :busy="!!cancel"
                    :items="items"
                    :fields="fields"
                    :no-local-sorting="true"
                    :sort-icon-left="true"
                    @sort-changed="sortingChanged"
                >
                  <template #cell(actions)="row">
                    <button type="button" class="btn mr-1 btn-primary btn-xs" v-on:click="showEditModal(row.item)"><i class="fas fa-edit"></i> Edit</button>
                    <RemoveForm :object="row.item.name"
                                message="Please confirm removing side bet name"
                                :url="'/api/v1/sidebet-names/' + row.item.id"
                                @finish="handleItemsUpdate"
                    />
                  </template>
                </b-table>
              </div>
            </div>

            <div class="row mb-10">
              <div class="col-12">
                <b-pagination
                    class="float-right"
                    v-model="pagination.page"
                    :total-rows="pagination.records"
                    :per-page="pagination.onPage"
                    @change="onPageChange"
                    first-number
                    last-number
                />
              </div>
            </div>

            <div class="row mt-10 mb-10">
              <div class="col-12">
                <ve-pagination
                    class="float-right"
                    :page-index="pagination.page"
                    :page-size="pagination.onPage"
                    :total="pagination.records"
                    :pagingCount="pagination.count"
                    :layout="['total', 'sizer']"
                    :pageSizeOption="pagination.pageSizeOption"
                    @on-page-size-change="onPageSizeChange"
                />
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import {getRouteIcon, ROUTE_LIMITS} from "../../utils/routerIcons";
import EditForm from "../../components/SidebetName/EditForm";
import RemoveForm from "../../components/remove-form/RemoveForm.vue";

function getDefaultPagination() {
  return {
    onPage: 10,
    page: 1,
    records: 0,
    count: 0,
    pageSizeOption: [10, 25, 50, 100, 200],
  };
}

export default {
  components: {
    EditForm,
    RemoveForm
  },
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editModalTitle: null,
      creating: false,
      cancel: null,
      error: null,
      fields: [
        {key: 'id', label: 'Id', sortable: true},
        {key: 'name', label: 'Name', sortable: true},
        {key: 'actions', label: 'Actions', thStyle: {'width': '300px'}}
      ],
      items: [],
      sortBy: null,
      sortDesc: null,
      pagination: getDefaultPagination(),
    }
  },
  computed: {
    emptyText() {
      if (this.cancel) {
        return 'Loading items..';
      }

      if (this.error) {
        return this.error.toString();
      }

      return 'There are no records to show';
    },
    routeIcon: () => getRouteIcon(ROUTE_LIMITS),
  },
  methods: {
    saveSidebetName() {
      this.$refs.editForm.isValid().then(result => {
        if (!result) {
          return;
        }

        let data = this.$refs.editForm.getData();

        this
            .$http({
              url: this.creating ? '/api/v1/sidebet-names' : '/api/v1/sidebet-names/' + data.id,
              data: this.creating
                  ? {id: data.id, name: data.name, config: data.config}
                  : {name: data.name, config: data.config},
              method: this.creating ? 'POST' : 'PUT',
              headers: {
                'Content-Type': 'application/json',
              },
            })
            .then(() => {
              setTimeout(() => {
                this.$refs.editFormModal.hide();
              }, 500);

              this.$toastr.i('Success');
              this.loadItems();
              this.$store.dispatch('limits/reloadSidebetNames');
            })
            .catch((err) => {
              this.$toastr.e(JSON.stringify(err.response.data.message));

              throw err;
            });
      })
    },
    showEditModal(data) {
      this.creating = !data.id;
      this.editModalTitle = data.id ? 'Edit side bet name' : 'Create side bet name';
      this.$refs.editFormModal.$root.$on('bv::modal::shown', () => {
        this.$refs.editForm.setData(data)
      })
      this.$refs.editFormModal.show();
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.pagination.page = 1;

      this.loadItems();
    },
    handleItemsUpdate() {
      this.loadItems();
      this.$store.dispatch('limits/reloadSidebetNames');
    },
    loadItems: function () {
      this.items = [];

      let self = this;
      const params = {
        limit: this.pagination.onPage,
        offset: this.pagination.onPage * (this.pagination.page - 1),

        orderBy: this.sortBy,
        direction: this.sortDesc ? 'DESC' : 'ASC',
      };

      this
          .$http({
            url: '/api/v1/sidebet-names',
            params: params,
            method: 'GET',
            cancelToken: new axios.CancelToken(c => { self.cancel = c; })
          })
          .then(resp => {
            let {items, pagination: {limit, totalCount}} = resp.data;

            this.items = items;
            this.pagination.onPage = limit;
            this.pagination.records = totalCount;
          })
          .catch((err) => {
            this.items = [];
            this.error = err;
          })
          .finally(() => {
            this.cancel = null;
          });
    },
    onPageChange(page) {
      this.pagination.page = page;
      this.loadItems()
    },
    onPageSizeChange(pageSize) {
      this.pagination.page = 1;
      this.pagination.onPage = pageSize;
      this.loadItems();
    },
  },
  mounted() {
    this.loadItems();
  }
}
</script>
